import { render, staticRenderFns } from "./title_components.vue?vue&type=template&id=71c45ca4&scoped=true&"
import script from "./title_components.vue?vue&type=script&lang=js&"
export * from "./title_components.vue?vue&type=script&lang=js&"
import style0 from "./title_components.vue?vue&type=style&index=0&id=71c45ca4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c45ca4",
  null
  
)

export default component.exports